 var collage_play_button = document.getElementsByClassName("collage_icon_play");
  var collage_video_cover_image = document.getElementsByClassName("collage_video_cover_image");                                                           
  var collage_video = document.getElementsByClassName("collage_video");

  var collage_video_autoplay = document.getElementsByClassName("collage_video_autoplay"); 
  var collage_video_autoplay_button = document.getElementsByClassName("collage_video_autoplay_button");
  var collage_video_autoplay_image = document.getElementsByClassName("collage_video_autoplay_image");

  for(let j=0; j < collage_video_autoplay_button.length; j++){
      collage_video_autoplay_button[j].style.display = "none";
      collage_video_autoplay_image[j].style.display = "none";
      collage_video_autoplay[j].play();
    }

  for(let i=0; i < collage_play_button.length; i++){
    collage_play_button[i].onclick = () => {
      collage_play_button[i].style.display = "none";
      collage_video_cover_image[i].style.display = "none";
      collage_video[i].play();     
    }
  }

  